<template>
  <div class="yn-container">
    <div><Button @click="toBack">返回</Button></div>
    <div class="order-detail-title">
      <!-- <span class="order-code">订单号：{{orderDetail.orderCode}}</span> -->
      <span class="order-code">订单状态：{{orderDetail.orderState+''|formatState}}</span>
      <!-- <span>支付状态：{{orderDetail.stateName}}</span> -->
    </div>
    <div class="order-msg">
      <div class="msg-item">
        <ul>
          <li>
            <div>患者姓名</div>
            <div>{{orderDetail.patientName}}</div>
          </li>
          <li>
            <div>性别</div>
            <div>{{orderDetail.sex==1?'女':'男'}}</div>
          </li>
          <li>
            <div>年龄</div>
            <div>{{orderDetail.patientAge}}{{orderDetail.ageUnit}}</div>
          </li>
          <li>
            <div>联系方式</div>
            <div>{{orderDetail.patientPhone}}</div>
          </li>
        </ul>
      </div>
      <div class="msg-item">
        <ul>
          <li>
            <div>医生姓名</div>
            <div>{{orderDetail.doctorName}}</div>
          </li>
          <li>
            <div>医生电话</div>
            <div>{{orderDetail.doctorPhone}}</div>
          </li>
          <li>
            <div>客户名称</div>
            <div>{{orderDetail.hospitalName}}</div>
          </li>
          <li>
            <div>客户地址</div>
            <div>{{orderDetail.hospitalAddress}}</div>
          </li>
        </ul>
      </div>
      <div class="msg-item noMarginRight">
        <ul>
          <li>
            <div>下单时间</div>
            <div v-if="orderDetail.submitTime">{{orderDetail.submitTime|formatDate('01','03')}}</div>
          </li>
          <li>
            <div>采样时间</div>
            <div v-if="orderDetail.samplingTime">{{orderDetail.samplingTime|formatDate('01','03')}}</div>
          </li>
          <li>
            <div>项目数量</div>
            <div v-if="orderDetail.projectNum">{{orderDetail.projectNum}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="order-detail-title barcode">
      <span class="order-code">检验条形码：{{orderDetail.specimenBarCode|arrTostring}}</span>
    </div>
    <div class="order-msg">
      <div class="msg-item project-msg noMarginRight">
        <ul>
          <li>
            <div>检测项目</div>
            <div id="project" ref="project">{{orderDetail.projectName|arrTostring}}</div>
          </li>
          <li>
            <div>订单金额</div>
            <div>{{orderDetail.amount}}</div>
          </li>
          <li>
            <div>备注</div>
            <div>{{orderDetail.remark}}</div>
          </li>
        </ul>
        <div class="apply-pic" >
          <div>申请单</div>
          <div class="img-list">
            <viewer :images="picArr" v-if="picArr.length>0">
              <img v-for="src in picArr" v-lazy="src" :key="src">
            </viewer>
            <span v-else>暂无申请单</span>
          </div>
        </div>
        <div class="apply-pic" v-if="reportList.length>0">
          <div>报告单</div>
          <div class="img-list">
            <viewer :images="reportList">
              <img v-for="src in reportList" v-lazy="src" :key="src">
            </viewer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail,getPDF } from "./../../api/outside";
import { formatDate,arrTostring,formatState } from "../../tools";
import { dictList } from "./../../api/common";
export default {
  name: "OrderDetail",
  data() {
    return {
      orderDetail: [],
      picArr: [],
      stateList: [],
      reportList: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getDetailMsg(this.$route.params.id);
    },
    getDetailMsg(id) {
      orderDetail({ id }).then(res => {
        console.log(res);
      
        this.picArr = []; //置空申请单图片
        let apply = res.orderApplyAttachmentIds;
        let arr = [];
        for (let i in apply) {
          arr.push(
            `${this.$url}common/common/downLoadFile?attachId=${
              apply[i]
            }&type=0`
          );
        }
        this.picArr = arr;
        
        this.orderDetail = res;
        let proArr = [];
        res.list.forEach(item => {
          proArr.push(item.name);
        });
        console.log(proArr);
        
        this.orderDetail.projectName = proArr;
        this.getReprt(id);
      });
    },
    //获取报告单
    getReprt(orderId){
      getPDF({
        id:orderId
      }).then(res=>{
        console.log(res);
        let reportArr = [];
        if (res.jpgList.length>0) {
          let report = res.jpgList;
          for (let i in report) {
            reportArr.push(
              `${this.$url}common/common/downLoadFile?attachId=${
                report[i]
              }&type=0`
            );
          }
          this.reportList = reportArr;
        }
      });
    },
    toBack(){
      this.$router.push({path:'/nopay'})
    }

  },
  filters: {
    formatDate,arrTostring,formatState
  }
};
</script>

<style scoped>
.order-detail-title {
  color: rgba(51, 51, 51, 1);
  margin-top:20px;
}
.order-code {
  margin-right: 100px;
}
.order-msg {
  margin-top: 19px;
  overflow: hidden;
}
.order-msg > div {
  float: left;
  width: 32%;
  margin-right: 2%;
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 80, 126, 0.1);
  border-radius: 4px;
}
.order-msg > div.noMarginRight {
  margin-right: 0;
}
.msg-item li {
  overflow: hidden;
  border-bottom: 1px solid rgba(234, 237, 241, 1);
}
.msg-item li > div {
  float: left;
  padding-top: 14px;
  padding-bottom: 13px;
}
.msg-item li > div:nth-child(1) {
  text-align: center;
  width: 35%;
  color: rgba(51, 51, 51, 1);
  border-right: 1px solid rgba(234, 237, 241, 1);
  font-weight: bold;
}
.msg-item li > div:nth-child(2) {
  padding-left: 50px;
}
.barcode {
  margin-top: 30px;
}
.order-msg .project-msg {
  width: 100%;
}
.order-msg .project-msg li > div:nth-child(1) {
  width: 12%;
}
.order-msg .project-msg li > div:nth-child(2) {
   width: 88%;
}
@media screen and (min-width: 1921px) {
  .order-msg .project-msg li > div:nth-child(2) {
    width: 88%;
  }
}
@media screen and (max-width: 1870px) {
  .order-msg .project-msg li > div:nth-child(2) {
    width: 83%;
  }
}
@media screen and (max-width: 1280px) {
  .order-msg .project-msg li > div:nth-child(2) {
    width: 70%;
  }
}
.apply-pic {
  overflow: hidden;
}
.apply-pic > div {
  float: left;
}
.apply-pic > div:nth-child(1) {
  width: 183px;
  font-weight: bold;
  text-align: center;
  padding-top: 14px;
}
.img-list {
  padding-top: 36px;
  padding-bottom: 27px;
}
.img-list img {
  display: inline-block;
  width: 120px;
  height: 120px;
  margin-right: 15px;
}
</style>




// WEBPACK FOOTER //
// src/views/common/ReportDetail.vue